import { createContext } from '@fluentui/react-context-selector'

import { AppContext } from './interfaces'

const StoreContext = createContext<AppContext>({
    appState: undefined,
    dispatch: () => ({}),
})

export default StoreContext